import Icon from '../components/Icon.vue'

Icon.register({
  neuter: {
    width: 288,
    height: 512,
    paths: [
      {
        d: 'M288 176C288 96.5 223.5 32 144 32S0 96.5 0 176C0 244.5 47.9 301.9 112 316.4V468C112 474.6 117.4 480 124 480H164C170.6 480 176 474.6 176 468V316.4C240.1 301.9 288 244.5 288 176zM144 256C99.9 256 64 220.1 64 176S99.9 96 144 96 224 131.9 224 176 188.1 256 144 256z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/neuter.js
// module id = HC72
// module chunks = 144